import { render, staticRenderFns } from "./google-form.vue?vue&type=template&id=c634592c&"
import script from "./google-form.vue?vue&type=script&lang=js&"
export * from "./google-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c634592c')) {
      api.createRecord('c634592c', component.options)
    } else {
      api.reload('c634592c', component.options)
    }
    module.hot.accept("./google-form.vue?vue&type=template&id=c634592c&", function () {
      api.rerender('c634592c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/reports/documents/components/google-form.vue"
export default component.exports